import ButtonGroupOption from '@atoms/ButtonGroupOption';
import { ButtonGroup, FormLabel, Stack, StackProps, Tooltip, Typography } from '@mui/material';
import { DIVISION_STYLE } from '@type/db-types';

interface Props extends Partial<Omit<StackProps, 'onChange'>> {
    onChange: (value: DIVISION_STYLE) => void;
    value: DIVISION_STYLE;
}

export default function BracketStyleForm({ onChange, value, ...rest }: Props) {
    return (
        <Tooltip
            title={
                <>
                    <Typography>
                        <em>Fixed Weight Classes:</em> Competitors are grouped into fixed weight
                        classes.
                    </Typography>
                    <Typography sx={{ paddingY: 1 }}>
                        <em>Madison System:</em> Competitors are grouped into brackets later based
                        on their weight and skill level.
                    </Typography>
                </>
            }
        >
            <Stack
                flexDirection={'row'}
                justifyContent={'space-evenly'}
                alignItems={'center'}
                {...rest}
            >
                <FormLabel sx={{ fontSize: '.9em', paddingRight: 1.5 }}>
                    Preferred Bracket Style:
                </FormLabel>
                <ButtonGroup variant="outlined" aria-label="limit division by">
                    <ButtonGroupOption
                        variant={
                            value === DIVISION_STYLE.FIXED_WEIGHT_CLASSES ? 'contained' : 'outlined'
                        }
                        selected={value === DIVISION_STYLE.FIXED_WEIGHT_CLASSES}
                        onClick={onChange.bind(null, DIVISION_STYLE.FIXED_WEIGHT_CLASSES)}
                    >
                        Fixed Weight Classes
                    </ButtonGroupOption>
                    <ButtonGroupOption
                        variant={value === DIVISION_STYLE.MADISON_SYSTEM ? 'contained' : 'outlined'}
                        selected={value === DIVISION_STYLE.MADISON_SYSTEM}
                        onClick={onChange.bind(null, DIVISION_STYLE.MADISON_SYSTEM)}
                    >
                        Madison System
                    </ButtonGroupOption>
                </ButtonGroup>
            </Stack>
        </Tooltip>
    );
}
